var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.nodes),function(node,n){return [(node)?_c('div',{key:'word_' + n,staticStyle:{"display":"inline-block"}},[(n % 2)?_c('label-text',{attrs:{"to":node}}):[_c('div',{directives:[{name:"linkified",rawName:"v-linkified"}],attrs:{"tag":"span"},domProps:{"innerHTML":_vm._s(_vm.sanitize(node))}})]],2):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3716f771","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/specialtext.vue
// module id = null
// module chunks = 